var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIndustrialOmniverse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D5EBEF",
  d: "M4.6 21.7c-.1 0-.3-.1-.4-.2-.2-.2-.2-.5 0-.7l1.5-1.4C2.7 18.8.3 16.2.3 13c0-3.6 2.9-6.5 6.5-6.5 2.8 0 5.3 1.8 6.2 4.5l.2.7c.1.3-.1.5-.4.6s-.5-.1-.6-.4l-.2-.7C11.5 9 9.4 7.5 7 7.5 4 7.5 1.5 10 1.5 13S4 18.5 7 18.5h1.3l-3.3 3c-.1.2-.2.2-.4.2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#42A5F2",
  d: "M19 19.5c-2.1 0-4.1-1-5.3-2.8-.2-.2-.1-.5.1-.7s.5-.1.7.1c1 1.5 2.7 2.3 4.5 2.3 3 0 5.5-2.5 5.5-5.5S22 7.4 19 7.4c-.6 0-1.1.1-1.6.2l-1.4.6 2.6-3.7c.2-.2.5-.3.7-.1s.3.5.1.7l-1 1.4h.6c3.6 0 6.5 2.9 6.5 6.5.1 3.6-2.9 6.5-6.5 6.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M13.1 16.8c-.3 0-.5-.2-.5-.5v-2c0-.3.2-.5.5-.5s.5.2.5.5v2c0 .3-.2.5-.5.5"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#86A7B2",
  d: "M13.1 16.8c-2.2 0-4.9-.3-7.9-1.3-.4-.1-.6-.5-.6-.8v-3.2c0-.3.1-.5.3-.7s.5-.2.7-.2c2.1.4 9.2 1.5 14.7-.3.3-.1.6 0 .8.1.2.2.4.4.4.7v3.1c0 .3-.2.6-.4.8-.8.4-3.5 1.8-8 1.8m-7.5-2.2c8.6 2.7 13.8.2 14.9-.4v-2.9c-5.6 1.8-12.7.7-14.9.3z"
})));
export default SvgIndustrialOmniverse;